import { commonTexts } from 'noddi-util';
import { useNavigate } from 'react-router-dom';
import { ErrorPage } from '../ErrorPages/ErrorPage';

interface ForbiddenPageProps {
  translations?: {
    forbiddenAccess: string;
    youDoNotHavePermission: string;
    goHome: string;
  };
}

const ForbiddenPage = ({ translations }: ForbiddenPageProps) => {
  const texts = translations ?? {
    forbiddenAccess: commonTexts.forbiddenAccess,
    youDoNotHavePermission: commonTexts.youDoNotHavePermission,
    goHome: commonTexts.goHome
  };
  const navigate = useNavigate();

  return (
    <ErrorPage
      title={texts.forbiddenAccess}
      description={texts.youDoNotHavePermission}
      buttonProps={{
        buttonText: texts.goHome,
        // oxlint-disable-next-line typescript/no-misused-promises -- ErrorPage onButtonClick is () => void; navigate('/') returns a promise that only tracks lazy-route loading
        onButtonClick: () => navigate('/')
      }}
    />
  );
};

// expect that all apps have same url to forbidden page
const forbiddenPageUrl = '/forbidden';

// eslint-disable-next-line react-refresh/only-export-components -- forbiddenPageUrl lives beside the page so apps import both from one place; only costs a full reload on edit
export { ForbiddenPage, forbiddenPageUrl };
